import BillingLogsDashboard from "./BillingLogsDashboard";

export default BillingLogsDashboard;
